.presurvey {
    padding: 0;
    margin: 0;
    height: 100vh;
    background: white;
    overscroll-behavior-y: none;
    position: relative;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

.presurvey__question {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    margin: 0 auto;
    max-width: 720px;
    width: 100%;
    padding: 0 2rem;
}

.presurvey__label > p {
    display: inline-block;
    margin: 0;
    padding: 0;
    vertical-align: middle;
    color: rgb(4, 69, 175);
    font-size: 16px;
}

.presurvey__label > p > span {
    font-size: 18px;
}

.presurvey__label > label {
    vertical-align: middle;
    font-size: 24px;
    line-height: 32px;
    margin-left: 1rem;
}

.presurvey__actions {   
    padding-left: 40px;
}

.presurvey__actions > textarea {
    overflow-x: hidden;
    overflow-wrap: break-word;
    margin-top: 2rem;
    appearance: none;
    display: block;
    width: 100%;
    font-family: inherit;
    color: rgb(4, 69, 175);
    border: none;
    outline: none;
    background-color: transparent;
    font-size: 30px;
    line-height: 38px;
    overflow-wrap: break-word;
    resize: none;
    overflow: hidden;
    transition: box-shadow 0.1s ease-out 0s;
    box-shadow: rgba(4, 69, 175, 0.3) 0 1px;
}

.presurvey__actions > small {
    display: block;
    color: rgb(4, 69, 175);
    margin-top: 1rem;
    font-size: 12px;
}

.presurvey__actions > button {
    display: inline-block;
    position: relative;
    font-weight: 700;
    cursor: pointer;
    transition-duration: 0.1s;
    transition-property: background-color, color, border-color, opacity, box-shadow;
    transition-timing-function: ease-out;
    outline: none;
    border: 1px solid transparent;
    margin: 1rem 0 0 0;
    box-shadow: rgba(0, 0, 0, 0.1) 0 3px 12px 0;
    padding-block: 6px;
    padding-inline: 14px;
    min-height: 40px;
    background-color: rgb(4, 69, 175);
    color: rgb(255, 255, 255);
    border-radius: 5px;
    font-size: 20px;
}

.action__hint {
    display: inline-block;
    color: black;
    font-size: 12px;
    margin-left: 1rem;
}

.error {
    margin-top: 1rem;
    display: inline-block;
    background: #f9e6e4;
    color: rgb(175, 4, 4);
    border-radius: 3px;
    font-size: 14px;
    padding: 4px 10px;
}

.error > svg {
    display: inline-block;
    fill: rgb(175, 4, 4);
    vertical-align: middle;
}

.error > span {
    vertical-align: middle;
}

::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color:  #cad5e2;
}

::-moz-placeholder { /* Firefox 19+ */
    color: #cad5e2;
}

:-ms-input-placeholder { /* IE 10+ */
    color: #cad5e2;
}
:-moz-placeholder { /* Firefox 18- */
    color: #cad5e2;
}